import * as React from "react";

function AlertTrianelgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M14.167 3.546c1.683-1.087 3.848-.488 4.83 1.237l.003.005 10.538 18.746.007.013a3.76 3.76 0 01.454 1.764c.02 1.955-1.463 3.668-3.45 3.69H5.45a3.368 3.368 0 01-1.73-.504c-1.664-1.025-2.192-3.239-1.265-4.95l.007-.013 10.54-18.746.002-.005c.285-.5.682-.926 1.163-1.237zm1.086 1.68c-.202.13-.379.315-.51.545l-.001.002L4.21 24.506c-.442.825-.154 1.849.56 2.288.216.134.456.203.699.207h21.064c.761-.011 1.477-.698 1.466-1.67v-.005a1.76 1.76 0 00-.209-.82L17.26 5.774l-.001-.002c-.444-.778-1.338-.976-2.005-.545zM14.5 22.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm.5-12.5v8h2v-8h-2z",
    clipRule: "evenodd"
  }));
}

export default AlertTrianelgeIcon;